import { t } from "@redotech/redo-i18n";
import { Condition as ModelCondition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import { ConversationPlatform } from "@redotech/redo-support-conversation-protocol-common/conversation-protocol";
import * as React from "react";
import { ConditionType } from "../return-flow/condition";
import { RuleTypeDetailsProps } from "./multiple-actions";

export type TicketChannelState = ConversationPlatform[];

export const TICKET_CHANNEL = (
  Details: React.ComponentType<RuleTypeDetailsProps<TicketChannelState>>,
): ConditionType<TicketChannelState, ModelCondition.TicketChannel> => ({
  name: CONDITION_NAMES[ModelCondition.TICKET_CHANNEL],
  description() {
    return t("Which channel the ticket came from");
  },
  Details(props: RuleTypeDetailsProps<TicketChannelState>) {
    return React.createElement(Details, props);
  },
  empty: [],
  fromModel(model) {
    return model.channels;
  },
  toModel(state) {
    return { type: ModelCondition.TICKET_CHANNEL, channels: state };
  },
  valid() {
    return true;
  },
});
